module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmh"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/tit#tit",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/copyrightnotice#notice",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright Notice")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ded#ded"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/author#aut"
    }
  }, [_vm._v("Author’s Note")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/pro#pro"
    }
  }, [_vm._v("Prologue")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Book One: "), _c('a', {
    attrs: {
      "href": "#/xhtml/part1#pt1"
    }
  }, [_vm._v("Encounters 1284")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("Chapter One. "), _c('a', {
    attrs: {
      "href": "#/xhtml/chapter1#ch1"
    }
  }, [_vm._v("The Countess")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("Chapter Two. "), _c('a', {
    attrs: {
      "href": "#/xhtml/chapter2#ch2"
    }
  }, [_vm._v("The Boy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("Chapter Three. "), _c('a', {
    attrs: {
      "href": "#/xhtml/chapter3#ch3"
    }
  }, [_vm._v("The Kings")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bot"
  }, [_vm._v("Chapter Four. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter4#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Meetings")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Book Two: "), _c('span', {
    attrs: {
      "href": "#/xhtml/part2#pt2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Noble Robert 1290")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("Chapter Five. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Laying on of Hands")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("Chapter Six. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter6#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Lairds of Lochmaben")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("Chapter Seven. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter7#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Patriarch")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("Chapter Eight. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter8#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Ride to Perth")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("Chapter Nine. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter9#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Family Ties")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bot"
  }, [_vm._v("Chapter Ten. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Alarums")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Book Three: "), _c('span', {
    attrs: {
      "href": "#/xhtml/part3#pt3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Siblings 1292")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("Chapter Eleven. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Surfeit of Roberts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("Chapter Twelve. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Silver Spurs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bot"
  }, [_vm._v("Chapter Thirteen. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Dangers of Ideas")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Book Four: "), _c('span', {
    attrs: {
      "href": "#/xhtml/part4#pt4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The English Lordling 1295–1297")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("Chapter Fourteen. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Politics of Love")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("Chapter Fifteen. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Politics of Friendship")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("Chapter Sixteen. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter16#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Natural Wrath")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("Chapter Seventeen. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter17#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The French Physician")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("Chapter Eighteen. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter18#ch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Enchantments and Intrigues")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("Chapter Nineteen. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter19#ch19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Confessions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("Chapter Twenty. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter20#ch20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Earl of Carrick’s Idyll")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("Chapter Twenty-One. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter21#ch21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kings’ Pleasures")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("Chapter Twenty-Two. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter22#ch22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Brief and Distant War")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("Chapter Twenty-Three. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter23#ch23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lochmaben Revisited")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("Chapter Twenty-Four. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter24#ch24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Death and Resurrection")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bot"
  }, [_vm._v("Chapter Twenty-Five. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter25#ch25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lessons in Loyalty")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bot"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/epi#epi",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/glossary#glo",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Glossary")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/adcard#ad",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Also by Jack Whyte")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/copyright#crt",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2176abdc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 63
// module chunks = 0